import {
  SAVED_FILTER_SET_TYPES,
  SAVED_FILTER_SET_VISIBILITIES
} from '@linearb/linjs-common';
import { SEARCH_DATE_FORMAT } from 'common/constants/constants';
import usePmSensorAuthId from 'components/hooks/PM/usePmSensorAuthId';
import { METHOD_NAMES } from 'modals/CreateEditProjectModal/consts';
import moment from 'moment';
import { useContext, useState } from 'react';

const useFormState = ({ filterSet, Context }) => {
  const {
    state: { localFilters }
  } = useContext(Context);
  const pmSensorId = usePmSensorAuthId();

  const [formState, setFormState] = useState({
    id: filterSet?.id || null,
    name: filterSet?.name || '',
    type: filterSet?.type || SAVED_FILTER_SET_TYPES.FILTER_SET,
    visibility: filterSet?.visibility || SAVED_FILTER_SET_VISIBILITIES.PRIVATE,
    due_date: filterSet?.metadata?.due_date || null,
    sensor_authorization_id: filterSet?.sensor_authorization_id || pmSensorId,
    filters: localFilters,
    is_pdt: Boolean(filterSet?.pdt_id),
    cadence: filterSet?.metadata?.cadence || null
  });
  /**
   * Updates the form state with the new input value.
   * @param {Event} e - The event object triggered by the input change.
   */
  const onInputChange = e => {
    setFormState(prevState => ({
      ...prevState,
      [e.target.name]: e.target.value
    }));
  };
  const onCadenceChange = newCadence =>
    setFormState(prevState => ({
      ...prevState,
      cadence: newCadence
    }));

  const onPdtChecked = e => {
    setFormState(prevState => ({
      ...prevState,
      is_pdt: e.target.checked,
      cadence: e.target.checked ? METHOD_NAMES.SCRUM.type : null
    }));
  };

  const onDueDateChange = date => {
    setFormState(prevState => ({
      ...prevState,
      due_date: date
    }));
  };

  const onTypeChange = e => {
    const isProject = e.target.value === SAVED_FILTER_SET_TYPES.PROJECT;
    const currentDate =
      filterSet?.metadata?.due_date ??
      moment().add(1, 'month').format(SEARCH_DATE_FORMAT);
    setFormState(prevState => ({
      ...prevState,
      type: e.target.value,
      due_date: isProject ? currentDate : null
    }));
  };

  return {
    formState,
    onInputChange,
    onCadenceChange,
    onPdtChecked,
    onDueDateChange,
    onTypeChange
  };
};

export default useFormState;
